<template>
  <div v-if="review">
    <div class="wrap-review-form">
      <label class="label-input">Information Review</label>
      <v-row>
        <v-col cols="12" md="12">
          <v-text-field v-model="review.fullName" label="Reviewer Full Name" />
        </v-col>
        <!-- Temporarily hide time -->
        <!-- <v-col cols="12" md="6">
          <ReviewDateTimeInput :value="review" @input="review = $event" />
        </v-col> -->
      </v-row>
      <v-text-field v-model="review.title" label="Review Title" />
      <div class="mb-5">
        <label class="label-input">Rating</label>
        <div class="mb-5">
          <v-rating
            color="warning"
            background-color="#c1c1c1"
            empty-icon="mdi-star-outline"
            full-icon="mdi-star"
            half-icon="mdi-star-half-full"
            hover
            length="5"
            size="35"
            v-model="review.star"
          >
          </v-rating>
        </div>
        <div v-if="typeReview === 'vital'">
          <div class="mb-6">
            <v-slider
              hide-details
              v-model="review.results"
              min="1"
              max="5"
              step="1"
              label="Results"
              :thumb-size="18"
              thumb-label="always"
            ></v-slider>
          </div>
          <div class="mb-6">
            <v-slider
              hide-details
              v-model="review.easeOfUse"
              min="1"
              max="5"
              step="1"
              label="Ease of Use"
              :thumb-size="18"
              thumb-label="always"
            ></v-slider>
          </div>
          <div class="mb-6">
            <v-slider
              hide-details
              v-model="review.taste"
              min="1"
              max="5"
              step="1"
              label="Taste"
              :thumb-size="18"
              thumb-label="always"
            ></v-slider>
          </div>
        </div>
      </div>
      <div class="mb-5">
        <label class="label-input">Avatar Image</label>
        <UploadImage
          @callback="onAvatarUploaded"
          :image="{ imageSrc: review.avatar }"
          :height="`150`"
          :typeUpload="'image'"
          @callbackDelete="onAvatarRemoved"
        />
      </div>

      <template v-if="typeReview === 'default'">
        <div class="mb-5">
          <label class="label-input">Content</label>
          <ckeditor v-model="review.content" :config="editorConfig" />
        </div>
      </template>

      <template v-else>
        <div class="mb-5">
          <label class="label-input">Content</label>
          <v-textarea v-model="review.content" rows="4" />
        </div>
      </template>

      <!-- replies -->
      <div v-if="typeReview !== 'default'" class="mb-5">
        <div class="mb-5">
          <label class="label-input">Reactions comments</label>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="review.like" label="Like" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="review.dislike" label="Dislike" />
            </v-col>
          </v-row>
        </div>
        <div>
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input" style="margin-bottom: 0">Admin replies</label>
            <v-btn small text color="primary" @click="handleAddReply">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Reply</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(reply, replyIndex) in review.replies" :key="replyIndex">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Reply {{ replyIndex + 1 }}</span>
                  <v-btn icon :disabled="review.replies.length <= 1" @click.stop="handleRemoveReply(replyIndex)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-text-field v-model="reply.content" label="Reply Content" class="mb-3" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
      <div>
        <div class="d-flex justify-space-between align-center mb-2">
          <label class="label-input"> Review Images ({{ (review.images && review.images.length) || 0 }}) </label>
          <v-btn small text color="primary" @click="startAddImage">
            <v-icon size="16">mdi-plus</v-icon>
            <span>Add Image</span>
          </v-btn>
        </div>
        <div class="review-images-grid" v-if="review.images && review.images.length > 0">
          <div v-for="(image, imageIndex) in review.images" :key="imageIndex" class="review-image-item">
            <div class="image-container">
              <img :src="image.src" alt="" @click="previewImage(image.src)" />
              <div class="image-overlay">
                <v-btn icon small @click="editImage(imageIndex)" class="edit-btn">
                  <v-icon size="16" color="white">mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon small @click="removeImage(imageIndex)" class="remove-btn">
                  <v-icon size="16" color="white">mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="no-images-placeholder">
          <p>No images added yet. Click "Add Image" to upload review photos.</p>
        </div>
      </div>
    </div>
  </div>
  <div v-else></div>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
// import ReviewDateTimeInput from './review-date-time-input.vue'

export default {
  name: 'ReviewAddForm',
  components: { UploadImage },

  props: {
    typeReview: { type: String, default: 'default' },
    value: { type: Object, required: true },
    editor: { type: Function, required: true },
    editorConfig: { type: Object, required: true },
  },
  computed: {
    review: {
      get() {
        console.log(this.value, '--> reviewaddForm');
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },
  methods: {
    onAvatarUploaded(obj) {
      if (obj && obj.imageSrc) {
        this.review = { ...this.review, avatar: obj.imageSrc };
      }
    },
    onAvatarRemoved() {
      this.review = { ...this.review, avatar: '' };
    },
    startAddImage() {
      // Emit to parent so it can open a shared image dialog if desired
      this.$emit('add-image');
    },
    previewImage(src) {
      this.$emit('preview-image', src);
    },
    editImage(imageIndex) {
      this.$emit('edit-image', imageIndex);
    },
    removeImage(imageIndex) {
      const images = (this.review.images || []).slice();
      images.splice(imageIndex, 1);
      this.review = { ...this.review, images };
    },
    handleAddReply() {
      this.review.replies.push({ content: 'Thank you for your feedback!' });
    },
    handleRemoveReply(replyIndex) {
      this.review.replies.splice(replyIndex, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.label-input {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  display: block;
}

.review-images-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}

.review-image-item {
  position: relative;
}

.image-container {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  width: 90px;
  height: 90px;
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.image-container:hover .image-overlay {
  opacity: 1;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-overlay .edit-btn,
.image-overlay .remove-btn {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.no-images-placeholder {
  text-align: center;
  padding: 40px 20px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  color: #666;
  margin-top: 16px;
}

.no-images-placeholder p {
  margin: 0;
  font-style: italic;
}
</style>
